var _ = require('underscore');
module.exports = function(obj){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
with(obj||{}){
__p+='<div> <div id="setting_margin" class="setting_margin div100"> <div id="module_margin" class="div100"> <div class="" style="background-image: url(\'/images/iphone12_2.png\'); width: 260px; height: 531px; z-index:100000;overflow:hidden"> <iframe id="eventApp_eventApp" scrolling="no" frameborder="0" style="overflow-y:auto; overflow:hidden;  width:240px; height: 512px; left:1px;top:9px;position:relative; z-index:0;border-radius: 34px"></iframe> </div> </div> </div> </div>';
}
return __p;
};
